
import {
  AgendamentoRPA,
  Usuario,
  FuncaoRPAScript
} from '../index';


export class FuncaoRPA {
  "Nome";
  "TransacaoSap";
  "DataCadastro";
  "UsuarioCadastro";
  "DataAlteracao";
  "UsuarioAlteracao";
  "id";
  AgendamentoRPA;
  UsuarioCadastroRel;
  UsuarioAlteracaoRel;
  FuncaoRPAScript;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FuncaoRPA`.
   */
  static getModelName() {
    return "FuncaoRPA";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FuncaoRPA for dynamic purposes.
  **/
  static factory(data) {
    return new FuncaoRPA(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'FuncaoRPA',
      plural: 'FuncaoRPAs',
      path: 'FuncaoRPAs',
      properties: {
        "Nome": {
          name: 'Nome',
          type: 'string'
        },
        "TransacaoSap": {
          name: 'TransacaoSap',
          type: 'string'
        },
        "DataCadastro": {
          name: 'DataCadastro',
          type: 'Date'
        },
        "UsuarioCadastro": {
          name: 'UsuarioCadastro',
          type: 'number'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
        "UsuarioAlteracao": {
          name: 'UsuarioAlteracao',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        AgendamentoRPA: {
          name: 'AgendamentoRPA',
          type: 'AgendamentoRPA[]',
          model: 'AgendamentoRPA'
        },
        UsuarioCadastroRel: {
          name: 'UsuarioCadastroRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        UsuarioAlteracaoRel: {
          name: 'UsuarioAlteracaoRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        FuncaoRPAScript: {
          name: 'FuncaoRPAScript',
          type: 'FuncaoRPAScript[]',
          model: 'FuncaoRPAScript'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/FuncaoRPA.js